import React, {useCallback} from "react";
import styled from "styled-components";
import Button from "../Shared/Button";
import {ProfileBeaconControl, ProfileBeaconControlGroup} from "../Shared/ProfileBeaconComponents";
import {getDomain, getWebDomain, isInternal} from "../../utils/api";
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import {getAlwaysChallenge} from "../../redux/profile/selectors";
import {setAlwaysChallengeMfa} from "../../redux/profile/slice";

const StyledLoginInfo = styled.div`
  margin-top: 24px;
  padding: 32px 40px;
  background-color: #fff;
  font-family: "Nimbus Sans Novus Regular";
  @media only screen and (max-width: 480px) {
    margin-top: 16px;
  }
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    padding: 24px;
  }
`;
const StyledCheckboxLabel = styled.label`
`;

const StyledHeader = styled.div`
  border-bottom: 1px solid #bec3c8;
  font-family: "Nimbus Sans Novus Bold";
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  color: #3b4b59;
  text-align: left;
  padding-bottom: 7px;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const StyledSubHeader = styled.div`
  margin-top: 24px;
  font-family: "Nimbus Sans Novus Bold";
  font-size: 20px;
  line-height: 1.4;
  letter-spacing: 0.02px;
  color: #3b4b59;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledCredentialsContainer = styled.div`
  padding: 11px 0 9px 0;
  flex-grow: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledTitle = styled.div`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  a {
    cursor: pointer;
  }
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledSecurityContainer = styled.div`
  padding: 11px 0 9px 0;
  flex-grow: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1240px) {
    display: flow-root;
  }
  @media (max-width: 768px) {
    display: flow-root;
  }
`;

const StyledLoginInfoButtonContainer = styled.div`
  float: right;
  @media (max-width: 1240px) {
    padding: 14px 0 10px 0;
  }
`;

const StyledCheckboxContainer = styled.div`
  display: inline-block;
  margin-top: 8px;
  @media (max-width: 768px) {
    margin-top: 8px;
    --beacon-form-label-font-size: 16px;
  }
  @media (max-width: 640px) {
    margin-top: 4px;
    --beacon-form-label-font-size: 16px;
  }
`;

const StyledCheckbox = styled(ProfileBeaconControl)`
font-weight: 300;
#checkbox-1{
border: 1px solid #929BA3;}

  --beacon-form-label-font-size: 18px;
  @media (max-width: 768px) {
    --beacon-form-label-font-size: 16px;
  }
  .checkbox{
  font-family :"Nimbus Sans Novus Regular";}
`;


const StyledFooter = styled.div`
  margin-top: 32px;
  a {
    color: #086ea1;
    text-decoration: underline;
    text-decoration-skip-ink: none;
    text-underline-offset: 1.5px;
    font-size: 18px;
    @media (max-width: 768px) {
      font-size: 16px;
    }
    &:hover,
    &:focus {
      text-decoration: underline;
      text-decoration-skip-ink: none;
      text-underline-offset: 1.5px;
    }
  }

 
`;

export const LoginInformationCard = () => {
    const dispatch = UseAppDispatch();
    const alwaysChallenge = UseAppSelector(getAlwaysChallenge);

    const loadUserNamePage = () => {
        document.location.href = getDomain() + "/usis/login/update/username?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=" + getDomain() + "/workplace/en/participant/profile/index.html";
    }
    const loadPasswordPage = () => {
        document.location.href= getDomain() + "/usis/login/update/password?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=" + getDomain() + "/workplace/en/participant/profile/index.html";
    }
    const loadPasskeyPage = () => {
        document.location.href= getDomain() + "/usis/login/update/passkeys?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=" + getDomain() + "/workplace/en/participant/profile/index.html";
    }
    const loadSecurityQuestionsPage = () => {
        document.location.href= getDomain() + "/usis/login/update/kba?pdurl=/clx-tk/token-exchange/redirect/default%3fsdurl=" + getDomain() + "/workplace/en/participant/profile/index.html";
    }
    const loadMultiFactorAuthenticationPage = () => {
        document.location.href= getDomain() + "/usis/login/update?pdurl==/clx-tk/token-exchange/redirect/default%3fsdurl=" + getDomain() + "/workplace/en/participant/profile/index.html";
    }
    const accountProtectionProgram = () => {
        document.location.href= getWebDomain() + "/rps/rws/account/participant/content-page.otc?path=en/secure/planning/financial-wellness/account-protection-program.html";
    }

    const handleAlwaysChallengeChange = useCallback((event: any) => {
        const alwaysChallenge = !event.target.checked;
        dispatch(setAlwaysChallengeMfa({alwaysChallenge}));
    }, [dispatch])

    return (
        <StyledLoginInfo>
            <StyledHeader>
                Login Information
            </StyledHeader>
            <StyledSubHeader>
                Credentials
            </StyledSubHeader>
            <StyledCredentialsContainer>
                <StyledTitle>User Name</StyledTitle>
                <Button variant="tertiary" isLink={true}  onBeaconClick={() => isInternal()? "" : loadUserNamePage()} buttonTitle="Change User Name"/>
            </StyledCredentialsContainer>
            <StyledCredentialsContainer>
                <StyledTitle>Password</StyledTitle>
                <Button variant="tertiary" isLink={true} onBeaconClick={() => isInternal()? "" : loadPasswordPage()} buttonTitle="Change Password"/>
            </StyledCredentialsContainer>
            <StyledCredentialsContainer>
                <StyledTitle>Passkey</StyledTitle>
                <Button variant="tertiary" isLink={true} onBeaconClick={() => isInternal()? "" : loadPasskeyPage()} buttonTitle="Manage Passkey"/>
            </StyledCredentialsContainer>
            <StyledSubHeader>
                Additional Security
            </StyledSubHeader>
            <StyledSecurityContainer>
                <StyledTitle>Security Question</StyledTitle>
                <StyledLoginInfoButtonContainer>
                    <Button variant="tertiary" isLink={true} onBeaconClick={() => isInternal()? "" : loadSecurityQuestionsPage()} buttonTitle="Change Security Question"/>
                </StyledLoginInfoButtonContainer>

            </StyledSecurityContainer>
            <StyledSecurityContainer>
                <StyledTitle>Multi-Factor Authentication</StyledTitle>
                <StyledLoginInfoButtonContainer>
                    <Button  variant="tertiary" isLink={true} onBeaconClick={() => isInternal()? "" : loadMultiFactorAuthenticationPage()} buttonTitle="Change Authentication Settings"/>
                </StyledLoginInfoButtonContainer>

            </StyledSecurityContainer> 
            <StyledCheckboxContainer>
              <ProfileBeaconControlGroup>
                <StyledCheckbox inline>
                  <label slot='label' htmlFor='checkbox-1'><StyledCheckboxLabel slot="label" htmlFor="checkbox-1"className="checkbox"> Challenge me every time I login</StyledCheckboxLabel></label>
               
              <input type="checkbox" name="checkbox-1" id="checkbox-1"
               value={alwaysChallenge}
               checked={alwaysChallenge}
               onInput={!isInternal() && handleAlwaysChallengeChange}
               disabled={isInternal()}
               />
                </StyledCheckbox>
              </ProfileBeaconControlGroup>
                {/* <StyledCheckbox inline >
                  <label slot="label" htmlFor="checkbox-1" > Challenge me every time I login</label>
                <input */}
                {/* label="Challenge me every time I login"
                    id="checkbox-1"
                    value={alwaysChallenge}
                    checked={alwaysChallenge}
                    onInput={!isInternal() && handleAlwaysChallengeChange}
                    disabled={isInternal()} */}


                
                {/* // type="checkbox"
                //  id="checkbox-1"
                //  name="checkbox-1"
                //  value={alwaysChallenge}
                // checked={alwaysChallenge}
                //  onInput={!isInternal() && handleAlwaysChallengeChange}
               
                //  onInput={shouldHandleInput ? handleInput : undefined}


                //  disabled={isInternal()}
                /> */}
              
                {/* </StyledCheckbox> */}
                
            {/* <beacon-control inline="">
              <label slot="label" for="citizen">U.S. Citizen</label>
              <input type="checkbox" name="citizen" id="citizen">
            </beacon-control>
          </beacon-control-group> */}
                   

              
            </StyledCheckboxContainer>
            <StyledFooter>
                <StyledTitle>Learn how our <a onClick={() => accountProtectionProgram()} >Account Protection Program</a>
                    &nbsp;keeps you covered in the event of fraud.</StyledTitle>
            </StyledFooter>
        </StyledLoginInfo>
    )
}